import { Doughnut, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Doughnut.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        legendPosition: {
            type: String,
            default: "right"
        }
    },
    computed: {
        options () {
            return {
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            const label = `${numeral(data.datasets[0].data[tooltipItem.index]).format("0,0")} ${data.labels[tooltipItem.index]}`
                            let suffix = ""
                            if(data.datasets[0]._total) {
                                const percent = numeral((data.datasets[0].data[tooltipItem.index] / data.datasets[0]._total) * 100).format("0,0")
                                suffix = ` (${percent}%)`
                            }
                            return `${label}${suffix}`
                        }
                    }
                },
                legend: {
                    display: true,
                    position: this.legendPosition,
                    reverse: true,
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                annotation: {
                    drawTime: "afterDatasetsDraw",
                    annotations: []
                }
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
